import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppThunk } from "app/store";
import { RootState } from "app/rootReducer";

interface LogsState {
  logs: Array<Log> | undefined;
}

type Log = {
  id: number;
  userId: number;
  dateTime: Date;
  note: string;
  type: number;
};

const initialState: LogsState = {
  logs: undefined,
};

const slice = createSlice({
  name: "logs",
  initialState,
  reducers: {
    setLogs(state, action: PayloadAction<Array<Log>>) {
      var logs = action.payload;

      return {
        ...state,
        logs: logs,
      };
    },
  },
});

export const { setLogs } = slice.actions;

/**
 * Selectors
 */
export const getLogs = (state: RootState) => state.logs.logs;

export default slice.reducer;

// Thunks
export const GetLogsThunk = (): AppThunk => async (dispatch: any) => {
  try {
    /// dispatch(setLoginSuccess(appContext));
  } catch (e) {
    // dispatch(setIsAuthenticated(false));
  }
};
